import { Layer } from 'shared/map-exports';
import { usePoisState } from 'state/usePoisState';
import { MapClickGetPois, MapLayerProps } from 'features/mapping/mapping.types';
import { GasPipelinePoi } from 'features/mapping/components/dialogs/PoiDialog/PoiDialog.types';
import { addVisible } from 'shared/addVisible';
import { getWatchdutyStaticTileUrl } from 'features/mapping/components/layers/layers.utils';
import { useStaticTileCacheDomain } from 'features/mapping/hooks/useStaticTileCacheDomain';
import { i18n } from 'i18n/config';
import { OVERLAY_ICONS_BEFORE_ID } from 'features/mapping/styles';
import { VisibilityToggledSource } from '../VisibilityToggledSource';
import { NaturalGasPipelineType } from './types';
import {
  GAS_MAPTILES_DIRECTORY,
  GAS_MAP_INTERACTIVE_LAYER_ID,
  GAS_MAP_LAYER_ID,
  GAS_SOURCE_DATA_LAYER,
} from './constants';
import {
  gasLayerStyle,
  getSelectedStrokeStyle,
  getInteractiveLayerStyle,
  layerStyleLineCasingGas,
} from './layerStyles';

export const gasPipelineClickHandler: MapClickGetPois<
  NaturalGasPipelineType
> = (geoJsonFeatures) => {
  return geoJsonFeatures.map((feature) => {
    const gasPipeline: NaturalGasPipelineType = feature.properties;
    const metadata: GasPipelinePoi = {
      title: i18n.t('map.poi.gasPipelines.title'),
      list: [
        {
          name: i18n.t('map.poi.gasPipelines.operator'),
          value: gasPipeline.Operator,
        },
        {
          name: i18n.t('map.poi.gasPipelines.type'),
          value: gasPipeline.TYPEPIPE,
        },
      ],
    };

    return {
      type: 'gasPipeline',
      id: gasPipeline.FID,
      metadata,
    };
  });
};

export const GasPipelineLayer = (props: MapLayerProps): JSX.Element => {
  const { visible } = props;
  const { selectedPoi } = usePoisState();
  const staticTileCacheDomain = useStaticTileCacheDomain();

  const selectedGasUId =
    (selectedPoi?.type === 'gasPipeline' && selectedPoi.id) || '';

  const selectedStrokeStyle = getSelectedStrokeStyle({
    selectedId: selectedGasUId,
    sourceLayer: GAS_SOURCE_DATA_LAYER,
  });

  return (
    <VisibilityToggledSource
      visible={visible}
      url={getWatchdutyStaticTileUrl(
        GAS_MAPTILES_DIRECTORY,
        staticTileCacheDomain,
      )}
    >
      <Layer
        beforeId={OVERLAY_ICONS_BEFORE_ID}
        {...addVisible(layerStyleLineCasingGas, visible)}
      />
      <Layer
        id={GAS_MAP_LAYER_ID}
        beforeId={OVERLAY_ICONS_BEFORE_ID}
        {...addVisible(gasLayerStyle, visible)}
      />
      <Layer
        id={GAS_MAP_INTERACTIVE_LAYER_ID}
        beforeId={OVERLAY_ICONS_BEFORE_ID}
        {...addVisible(
          getInteractiveLayerStyle(GAS_SOURCE_DATA_LAYER),
          visible,
        )}
      />
      <Layer
        beforeId={OVERLAY_ICONS_BEFORE_ID}
        {...addVisible(selectedStrokeStyle, visible)}
      />
    </VisibilityToggledSource>
  );
};
